<button [class]="class" type="submit" [disabled]="loading || disabled" [id]="id">
    <mc-loading *ngIf="loading" [color]="loadingColor" size="sm"></mc-loading>
    {{ text }}
</button>
